// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-list__community-rules[data-v-64ab5b16]{margin:10px;padding:20px;border:1px solid rgba(122,123,151,.3);box-shadow:0 4px 8.8px rgba(166,166,185,.55);border-radius:10.4px}.text-topic[data-v-64ab5b16]{font-weight:700;margin-left:16px;color:#3b3e66}", ""]);
// Exports
module.exports = exports;
